import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class ServiceProviderFavoriteAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-favorite';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/favorites';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userUuid',
            'serviceProviderUuid',
            'serviceProviderContactUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }

}

export default ServiceProviderFavoriteAppResource;
